import Slider from '../services/sliderService';

export default function defaultSlider() {
    const elements = document.querySelectorAll('.js-default-slider');

    function createDefaultSlider(element, wrapper) {
        const options = {
            slideVisibleClass: 'default-slider__slider-item--visible',
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                1044: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
            },
            wrapperElement: wrapper,
        };

        return new Slider(element, options);
    }

    elements.forEach((element) => {
        const wrapper = element.closest('.default-slider');

        createDefaultSlider(element, wrapper);
    });
}
